export const ru = {
    'error.user-get.title': 'Произошла ошибка получения данных пользователя',
    'error.user-get.description': 'Вы можете написать репорт об ошибке в жука',
    'default-title': 'Хурал',
};